import { render, staticRenderFns } from "./StockTable.vue?vue&type=template&id=64c2c502&scoped=true"
import script from "./StockTable.vue?vue&type=script&setup=true&lang=js"
export * from "./StockTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StockTable.vue?vue&type=style&index=0&id=64c2c502&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c2c502",
  null
  
)

export default component.exports